import { useLocation, useNavigate } from "react-router-dom";
import { useSubscriptionGate } from "../queries/useSubscriptionGate";

const BILLING_PATH = "/settings/billing";

export interface BillingBannerVm {
  hidden: boolean;
  severity: "warning" | "error";
  message: string;
  actionLabel: string;
  onAction: () => void;
}

/**
 * View model for the app-wide billing notice. Owns visibility, severity, copy,
 * and the navigation handler so the banner component is pure render. Phase 1
 * enforcement is soft — it informs and links to billing rather than blocking.
 */
export function useBillingBanner(): BillingBannerVm {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isLoading, isActive, isPastDue, isBlocked } = useSubscriptionGate();

  const hidden =
    isLoading ||
    pathname === BILLING_PATH ||
    (isActive && !isPastDue) ||
    (!isPastDue && !isBlocked);

  return {
    hidden,
    severity: isPastDue ? "warning" : "error",
    message: isPastDue
      ? "Your last payment failed. Update your payment method to keep access."
      : "Your organization doesn't have an active subscription.",
    actionLabel: isPastDue ? "Fix payment" : "Subscribe",
    onAction: () => navigate(BILLING_PATH),
  };
}
